import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Form } from 'react-bootstrap'
import TreeView from 'react-treeview'
import Extra from './Extra.js'
import store from '../stores/store.js'

@inject("store")
@observer
export default class ExtraGroup extends Component {
  static propTypes = {
    extraGroup: PropTypes.object.isRequired,
    onClickExtra: PropTypes.func,
    showCheckboxes: PropTypes.bool
  }

  handleTreeClick = (id) => {
    const { store } = this.props
    store.toggleExtraGroupCollapsed(id)
  }

  handleSelection = (id) => {
    const { store } = this.props
    store.toggleExtraGroupSelection(id)
  }

  renderExtraGroup() {
    const { extraGroup, onClickExtra } = this.props

    if(onClickExtra) {
      return (
        <span
          onClick={() => onClickExtra({extraGroup})}
          style={{...styles.extra, ...styles.clickableExtraGroup}}
        >
          { extraGroup.name }
        </span>
      )
    }
    else {
      return <span style={styles.extra}>{ extraGroup.name }</span>
    }
  }

  renderExtraGroupCheckbox() {
    const { extraGroup, showCheckboxes } = this.props

    if(showCheckboxes) {
      return (
        <Form.Check
          type="checkbox"
          style={styles.checkbox}
          id={`extraGroup-${extraGroup.id}`}
          >
          <Form.Check.Input
            onChange={() => this.handleSelection(extraGroup.id)}
            checked={extraGroup.selected}
          />
          <Form.Check.Label>
            { this.renderExtraGroup() }
          </Form.Check.Label>
        </Form.Check>
      )
    }
    else {
      return this.renderExtraGroup()
    }
  }

  render() {
    const { extraGroup, showCheckboxes, onClickExtra } = this.props

    return (
      <TreeView
        onClick={() => this.handleTreeClick(extraGroup.id)}
        collapsed={extraGroup.collapsed}
        nodeLabel={this.renderExtraGroupCheckbox()}
        >
        <div style={styles.offset}>
          {extraGroup.extras.map(extra =>
            <Extra
              key={extra.id}
              extra={extra}
              onClickExtra={onClickExtra}
              showCheckboxes={showCheckboxes}
            />
          )}
        </div>
      </TreeView>
    )
  }
}

const styles = {
  checkbox: {
    display: "inline-block",
    marginTop: 0,
    marginBottom: 5
  },
  offset: {
    marginLeft: 10
  },
  clickableExtraGroup: {
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  extra: {},
}